import { connect } from 'react-redux';
// eslint-disable-next-line import/no-named-as-default
import ModalContainer from './ModalContainer';

const mapStateToProps = ({
  modalReducer,
  responsiblePersonReducer,
  tnReducer,
  userManualReducer
}) => ({
  modalReducer,
  responsiblePersonReducer,
  tnReducer,
  userManualReducer
});

const mapDispatchToProps = {
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalContainer);
